$( document ).ready(function() {
   $(".tr_donacion").on("click",function () {
      var id = this.id

      window.location.href = base_url+'/stock/detalle-donacion-contacto/'+id
   })
   $(".check_eliminar").on('click',function(){
   		var lista= $("#lista_eliminar").val('')
   		var lista_nueva='';
   		$( ".check_eliminar" ).each(function( index ) {
		 	if( $("#"+this.id).is(':checked') ) {
			    var id = this.id.split("_");
			    lista_nueva+=id[2]+'_'
			}
		});

   		$("#lista_eliminar").val(lista_nueva)

		if (lista_nueva !='') {
			$("#box_btn_eliminar").removeClass('d-none')
		}else{
			$("#box_btn_eliminar").addClass('d-none')
		}

   })


   $("#btn_eliminar").on('click',function(){
   		var lista = $("#lista_eliminar").val()
   		var menu = $("#menu").val()
		$.ajax({
	      	url: base_url+"/stock/eliminar_stock_elementos/"+menu+"/"+lista,
	      	method: 'get',
	      	data: '',
	      	success: function(result){
	      		location.reload()
	    	}}
	    );
		return false;
   })


   $(".guardar_cantidad").on('click',function(){
   		var id = this.id
   		var valor = $("#input_"+id).val();
   		var menu = $("#menu").val()
   		var id_edit_array = id.split('_');
   		var id_edit = id_edit_array[2];

		$.ajax({
	      	url: base_url+"/stock/actualizar_elementos/cantidad/"+menu+"/"+id_edit+"/"+valor,
	      	method: 'get',
	      	data: '',
	      	success: function(result){
	      		$("#link_"+id).attr('aria-expanded',false)
	      		$("#dropdown-menu_"+id).removeClass("show")
	      		$("#link_"+id).html(valor)

	      		$(".label_suma_resta_"+id_edit).html(valor)
	    	}}
	    );
		return false;
   })

    $('.urgency-dropdown__toggle').each(function() {
        let data = $(this).next('.urgency-dropdown__menu').children('.urgency-dropdown__item.active').data('urgency');
        $(this).children('span').html(data);
		$(this).attr('data-urgency', data);
    });

    $('.urgency-dropdown__item').on('click', function() {
        let data = $(this).data('urgency');
        $(this).closest('.urgency-dropdown').children('.urgency-dropdown__toggle').attr('data-urgency', data);
        $(this).closest('.urgency-dropdown').find('.urgency-dropdown__toggle span').html(data);

        let id = $(this).closest('.urgency-dropdown').attr('id'),
            valor = $(this).data('id'),
            menu = $('#menu').val(),
            id_edit_array = id.split('_'),
            id_edit = id_edit_array[2];

        $.ajax({
            url: `${base_url}/stock/actualizar_elementos/cat_urgencias_id/${menu}/${id_edit}/${valor}`,
            method: 'get',
            data: '',
            success: function(result){
            }
        });

        $(this).closest('.urgency-dropdown').dropdown('hide');
		return false;
    });

   $(".btn-sumar").on('click',function(){
   	var id = this.id
   	var valor = $("#input_"+id).val();
   	var id_input = id.split("_")
   	var valor_actual = $("#input_nueva_cantidad_"+id_input[1]).val();

   	$("#input_nueva_cantidad_"+id_input[1]).val(Number(valor)+Number(valor_actual));

   	return false;
   })

    $(".btn-restar").on('click',function(){
   	var id = this.id
   	var valor = $("#input_"+id).val();
   	var id_input = id.split("_")
   	var valor_actual = $("#input_nueva_cantidad_"+id_input[1]).val();

   	$("#input_nueva_cantidad_"+id_input[1]).val(Number(valor_actual)-Number(valor));

   	return false;
   })
});
